import {getReservationList, signReOrder} from "@/api";
import {addDateRange, message} from "../../utils/common";
import {ElMessageBox} from "element-plus";
import baseConfig from "@/api/config";
import {startReservationAutoRefresh, stopReservationAutoRefresh} from "@/assets/utils/reservationRefresh";

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            queryParams: {
                cardPatientName: '',
                cardIdentity: '',
                reStatusMiniDoc: '',
                cardPatientPhone: '',
                params: {}
            },
            tableLoading: false,
            listRequestInFlight: false,
            tableData: [],
            // 预约时间筛选默认留空 = 不按就诊日期过滤。该筛选项按就诊日期(doc_work_schedule.sch_date)归属，
            // 患者常提前预约未来日期，若默认给「今天往前一个月 → 今天」的区间，会把未来就诊的预约单
            // （待就诊单的主体）默认挡在列表外。留空即不过滤，由用户按需选择。
            dateTime: [],
            tableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            doctorInfo: null,
            reservationRefreshTimer: null,
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
        }
    },
    mounted() {
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
        },1000)
    },
    created() {
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
        }
        this.chooseDateTime();
        this.getReservationListInfo();
        startReservationAutoRefresh(this, () => this.getReservationListInfo(true));
    },
    beforeUnmount() {
        stopReservationAutoRefresh(this);
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },

        // 选择预约时间范围（按就诊日期过滤）
        // 未选区间时清空参数 = 不按时间过滤；区间截到今天就等于把未来就诊的预约单挡掉。
        chooseDateTime() {
            this.queryParams.params = {};
            if (Array.isArray(this.dateTime) && this.dateTime.length === 2
                && this.dateTime[0] && this.dateTime[1]) {
                addDateRange(this.queryParams, this.dateTime, "ReTime");
            }
        },

        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.cardPatientName = "";
            this.queryParams.reStatusMiniDoc = "";
            this.queryParams.cardIdentity = "";
            this.queryParams.cardPatientPhone = "";
            this.dateTime = [];
            this.chooseDateTime();
            this.currentPage = 1;
            this.getReservationListInfo();
        },

        // 选择预约状态
        chooseStatus() {
            this.currentPage = 1;
            this.getReservationListInfo();
        },

        // 切换分页
        handleCurrentChange: function(val) {
            this.currentPage = val;
            this.getReservationListInfo();
        },

        // 切换分页
        handleSizeChange: function(val) {
            this.pageNums = val;
            this.getReservationListInfo();
        },


        // 查询预约列表（silent=true 时为定时自动刷新，不清空表格、不显示 loading，避免面板闪烁）
        getReservationListInfo: function (silent = false) {
            // 上一轮自动刷新请求尚未返回时跳过本轮，避免请求堆积
            if (silent && this.listRequestInFlight) return;
            if (!silent) {
                this.tableData = [];
                this.tableLoading = true;
            }
            this.listRequestInFlight = true;
            const data = {
                pageNum: this.currentPage,
                pageSize: this.pageNums,
                doctorId: this.doctorInfo ? this.doctorInfo.doctorId : null,
                cardIdentity: this.queryParams.cardIdentity,
                cardPatientName: this.queryParams.cardPatientName,
                reStatusMiniDoc: this.queryParams.reStatusMiniDoc,
                cardPatientPhone: this.queryParams.cardPatientPhone,
                //在途单按签到序（queue_seq）排；历史单 queue_seq 为空，退化为 re_time/re_no 兜底
                queueOrder: '1',
                params: this.queryParams.params,
            };
            getReservationList(data).then(res => {
                const rdata = res.data;
                this.tableLoading = false;
                this.listRequestInFlight = false;
                if (rdata.code === 200) {
                    this.tableData = rdata.rows;
                    this.totalCount = rdata.total;

                    this.tableData.forEach((item) => {
                        let birYear = new Date(item.cardPatientBirth).getFullYear();
                        let nowYear = new Date().getFullYear();
                        item.age = parseInt(nowYear - birYear);
                        item.reTimeTypeText = item.reTimeType === 'am'?'上午': item.reTimeType === 'pm'?'下午':'晚上';
                        item.reStatusText = item.reStatus === '1'?'待支付':item.reStatus === '2'?
                            '已完成':item.reStatus === '3'?'已失效':item.reStatus === '4'?'已取消':item.reStatus === '5'?'待就诊':item.reStatus === '6'?'就诊中':item.reStatus === '7'?'已过号':item.reStatus === '8'?'待签到':'未知';
                        if (item.cardPatientSex === '0') {
                            item.sexText = '男';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else if (item.cardPatientSex === '1'){
                            item.sexText = '女';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else {
                            item.sexText = '未知';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    })
                }
            }).catch(error => {
                this.listRequestInFlight = false;
                // 静默刷新失败只记录，不弹错误提示，避免定时刷新反复弹窗
                if (silent) {
                    console.error("auto refresh failed:", error);
                } else {
                    message(error, "error");
                }
            });
        },


        // 签到
        handleSign(row) {
            const reId = row.reId;
            ElMessageBox.confirm('确定要签到？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
            }).then(() => {
                signReOrder(reId).then(res => {
                    if (res.code === 200) {
                        //后端签到时分配当天排队号，随签到结果回传
                        message(res.data ? "签到成功，排队" + res.data + "号" : "签到成功", "success");
                        this.getReservationListInfo();
                    } else {
                        message(res.msg || "签到失败", "warning");
                        this.getReservationListInfo();
                    }
                }).catch(error => {
                    message(error, "error");
                });
            }).catch(() => {});
        },

        // 接诊
        openMedical(row) {
            console.log(row);
            this.patientInfo.name = row.cardPatientName;
            this.patientInfo.sex = row.cardPatientSex;
            this.patientInfo.age = row.age;
            this.patientInfo.phoneNumber = row.cardPatientPhone;
            this.patientInfo.identity = row.cardIdentity;
            window.sessionStorage.removeItem("reservationPatient");
            window.sessionStorage.setItem("reservationPatient", JSON.stringify(this.patientInfo));

            this.$router.push({path: '/admin/clinictreat'});
            this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
        },


    }
}
